import type { DashboardFeatureOptions } from '.'
import { DashboardViewModel } from './DashboardView/DashboardViewModel'

export async function InternalDashboardFeature(
  options: DashboardFeatureOptions,
) {
  const createJobListViewModel = await options.createJobListViewModel
  const dashboardVm = new DashboardViewModel(
    options.getCurrentMember,
    options.listPublishedLegends,
    options.createNewDraftJob,
    createJobListViewModel,
    options.newSearchableJob$,
    options.listSearchableJobs,
    options.ensureTermsAcceptance,
    options.startHandoff,
    options.sessionOptions$,
  )

  return {
    // Internal
    dashboardVm,
  }
}
